import { PhonePrepareOutgoingEvent } from '@modules/SoftPhoneModule/types';
import { InboxContext } from '../types';
import TasksModule from '@modules/TasksModule';

function handleTaskPrepareOutbound(
  _context: InboxContext,
  eventData: PhonePrepareOutgoingEvent,
): void {
  const { outgoingNumber, displayName, tenantId } = eventData;
  TasksModule.createOutboundCallTask(outgoingNumber, displayName, tenantId);
}

export default handleTaskPrepareOutbound;
